// extracted by mini-css-extract-plugin
export default {"notification-bar-link":"RDE_NtQds6cgiEAranOQ"};